<script>
import Header from "@/components/Header.vue";
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import axios from "axios"
import _ from "lodash";
import {EventBus} from "@/eventBus";

export default {
  name: "InvoiceList",
  components: {Header},
  mixins: [
    ListLogicMixin
  ],
  data: () => {
    return {
      apiList: '/api/manager/invoice/list',
      apiUrl: '/api/manager/invoice/',
      apiMultyDelete: '/api/manager/invoice/delete',
      filterOptions: {},
      pageTitle: 'Invoices',
      pageFilter: '',
      pageTotal: '',
      total: 0,
      title: 'Invoices',
      allSelected: false,
      filterExact: [],
      items: [],
      queryFilter: [],
      options: [10, 20, 50, 100, 200, 1000],
      currentItem: {},
      itemsSelectedCount: 0,
      modalData: {
        "apiUrl": "/api/manager/invoice/",
        "redirectToUrl": "/invoice/list",
        "formData": {
          "Id": {
            "name": "Id",
            "type": "number",
            "value": "",
            "show": false,
            "class": ""
          },
          "EntityId": {
            "name":"EntityId",
            "label":"Datacenter",
            "value": "",
            "type":"select",
            "required":true,
            "show":true,
            "class": "",
            "url":"/api/manager/dc/list?sort=Id",
            "field":"Name",
            "toType":"number",
            "options":[]
          },
          "Entity": {
            "name": "Entity",
            "type": "text",
            "value": "dc",
            "show": false,
            "class": ""
          },
          "Name": {
            "name": "Name",
            "type": "text",
            "value": "",
            "required": true,
            "show": true,
            "class": ""
          },
          "PayPeriod": {
            "name": "PayPeriod",
            "type":"select",
            "value": "",
            "show": true,
            "class": "",
            "required":true,
            "options":[
              {
                "value": "month",
                "title": "month",
                "text": "month"
              },
              {
                "value": "2month",
                "title": "2 months",
                "text": "2 months"
              },
              {
                "value": "3month",
                "title": "3 months",
                "text": "3 months"
              },
              {
                "value": "6month",
                "title": "6 months",
                "text": "6 months"
              },
              {
                "value":"year",
                "title": "year",
                "text":"year"
              }
            ]
          },
          "PayDate": {
            "name": "PayDate",
            "type": "date",
            "value": "",
            "show": true,
            "class": ""
          }
        }
      },
      limit: "200"
    }
  },
  methods: {
    initFilters() {
      console.log('filterValues', this.filterValues)
    },
    editItem(item) {
      this.currentItemId = parseInt(item.Id);
      this.currentItem = item;
      this.$modal.show('editItem');
    },
    loadOptions: async  function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri) {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key)
        }
      })
      this.filterPreparing();
      this.filterQuery();
      this.LoadData();
    },
    getOptions: function (labelField, valueField, query, key) {
      const options = []
      axios.post(query, [], this.authRespConf())
          .then(res => {
            if (res === undefined || res === null) {
              return []
            }
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                options.push({
                  value: res.data.data[dataIndex][valueField],
                  label: key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField],
                });
              }
            }
          });
      return options;
    },
    selectAll: function () {
      this.selectedItemsList = [];
      this.itemsSelectedCount = 0
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    actionDelete() {
      this.confirmModalTitle = this.itemsSelectedCount > 1 ? 'Confirm delete Invoices' : 'Confirm delete Invoices';
      this.confirmModalMsg =
          'Are you sure you want to delete ' +
          document.getElementsByClassName('selected').length +
          ' Invoice?';
      this.$modal.show('confirm');
    },
    openDeleteItemConfirmation(item) {
      this.confirmModalTitle = `Confirm delete Invoice: ${item.Name}`;
      this.confirmModalMsg = `Are you sure you want to delete Invoice ${item.Name}`;
      this.currentItemId = parseInt(item.Id);
      this.$modal.show('confirmItemDelete');
    },
    extractDomain(str) {
      const domainPattern =  /(?:https?:\/\/)?(?:\(|\[)?([^\s\/\)\]]+\.[^\s\/\)\]]+\.[^\s\/\)\]]+|[^\s\/\)\]]+\.[^\s\/\)\]]+(?:\.[^\s\/\)\]]+)?)(?:\)|\])?/i; // eslint-disable-line
      const match = str.match(domainPattern);
      return match ? match[1] : null;
    },
    isURL(str) {
      const domain = this.extractDomain(str)
      if (!domain) return false;

      const urlPattern =  /(?:https?:\/\/)?(?:\(|\[)?([^\s\/\)\]]+\.[^\s\/\)\]]+\.[^\s\/\)\]]+|[^\s\/\)\]]+\.[^\s\/\)\]]+(?:\.[^\s\/\)\]]+)?)(?:\)|\])?/i;// eslint-disable-line
      return urlPattern.test(domain);
    },
    getLink(str) {
      const domain = this.extractDomain(str);
      const httpPattern = /^(?:https?:\/\/)/i;
      if (httpPattern.test(domain)) {
        return domain;
      }
      return `https://${domain}`
    },
  }
  ,
  computed: {}
  ,
  watch: {
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
      if (this.itemsSelectedCount === 0) {
        this.allSelected = false
      }
    }
    ,
    queryFilter: function (val) {
      const $this = this
      if (!_.isEqual(val, this.newFilters)) {
        let unnamedFilter = ""
        _.forEach(val, function (field) {
          unnamedFilter = unnamedFilter += $this.getUnnamedFilter(field)
        })
        if (unnamedFilter !== "") {
          $this.pageTitle = 'Invoices for: ' + unnamedFilter
        } else {
          $this.pageTitle = 'Invoices'
        }
      }
    }
    ,
  }
  ,
  created() {
    this.loadOptions();
    EventBus.$on("invoice-update", this.handleUpdate);
    EventBus.$on("invoice-rq", this.handleUpdate);
    EventBus.$on("invoice-add", this.handleAdd);
    EventBus.$on("invoice-delete", this.handleDelete);
    EventBus.$on("invoice-del", this.handleDelete);
  },
  beforeDestroy() {
    EventBus.$off("invoice-update", this.handleUpdate);
    EventBus.$off("invoice-rq", this.handleUpdate);
    EventBus.$off("invoice-add", this.handleAdd);
    EventBus.$off("invoice-delete", this.handleDelete);
    EventBus.$off("invoice-del", this.handleDelete);
  },
}
</script>

<template>
  <div class="page">
    <Header/>
    <div v-show="isDataVisible" class="container dashboard card">
      <div class="card-header">
        {{ pageTitle }}
        <span class="other-buttons"><button @click="newItemForm()"
                                            class="btn btn-primary">Add Invoice</button></span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select DCs to delete">
        <button class="btn btn-default delete-btn small icon-only"
                @click="actionDelete()"
                :class="['btn btn-danger', { 'disabled': itemsSelectedCount === 0 }]">
          Delete <span v-if="itemsSelectedCount <= 1">Invoice</span><span v-else>Invoices</span> <i
            class="fa fa-trash"></i>
        </button>
        </span>
      </div>
      <div class="card-body">
        <div class="alert alert-info alert-dismissable" v-show="info != ''">
          <strong>
            <b-icon icon="info-circle-fill"></b-icon>
          </strong>
          <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
        </div>
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Id')">ID</span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Name')">Name 🔡</span>
              <span class="icon-up" v-show="sortField === 'Name'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Name'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('PayDate')">Payment date 💵</span>
              <span class="icon-up" v-show="sortField === 'PayDate'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'PayDate'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th/>
            <th>
              <span class="col-text cursor-pointer">Links 🔗</span>
            </th>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td>
              <span class="cel-text">{{ item.Id }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Name }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.PayDate }} ({{ item.PayPeriod }})</span>
            </td>
            <td/>
            <td>
              <span class="cel-buttons">
                <button class="btn btn-as-link icon-only" @click="editItem(item)"><i class="fa fa-pencil"></i></button>
                <button class="btn btn-as-link icon-only  text-danger" @click="openDeleteItemConfirmation(item)"><i
                    class="fa fa-trash"></i></button>
              </span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items?.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="options"
        />
      </div>
    </div>
    <ModalItem
        type="edit"
        title="Edit Invoice:"
        updateTitleKey="Name"
        :itemId=currentItemId
        :item=currentItem
        :modalName="'editItem'"
        :height="486"
        :withLocalData=true
        :localData=modalData
        v-on:onSuccess="itemSuccess"/>
    <ModalItem
        type="create"
        title="New Invoice"
        :itemId="0"
        :modalName="'createItem'"
        :height="486"
        :withLocalData=true
        :localData=modalData
        v-on:onSuccess="itemSuccess"/>
    <ModalError name="listError" :message="error"/>
    <ModalSuccess name="listSuccess" :message="success"/>
    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        :url="apiUrl"
        :itemId="currentItemId"
    />
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>
  </div>
</template>

<style scoped>
::-webkit-scrollbar-thumb {
  background-image: linear-gradient(180deg, #d0368a 0%, #708ad4 99%);
}
::-webkit-scrollbar-track {
  background-color: #3b3d85;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
</style>
